import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { appGetAllSanstha } from '../../store/sanstha'
import { sansthaExportColumns } from '../../config/exportColumns/sansthaExportColumns'
import ExportButton from '../../common/ExportButton'
import { useState } from 'react'

function Sanstha() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [activeFilters, setActiveFilters] = useState({})
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Sanstha</div>

					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllSanstha({ ...params, loading: false }))}
							filters={activeFilters}
							columns={sansthaExportColumns}
							fileName="Sanstha_List"
							sheetName="Sanstha"
							buttonText="Export Sanstha"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/sanstha/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Sanstha
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Sanstha
